import { z } from 'zod';

export const cashInstructionSchema = z.object({
  instruction: z
    .string()
    .min(1, 'Instrukcja jest wymagana')
    .max(10000, 'Instrukcja może mieć maksymalnie 10 000 znaków'),
});

export type CashInstructionFormData = z.infer<typeof cashInstructionSchema>;
